import { render, staticRenderFns } from "./VIPRefundInfo.vue?vue&type=template&id=037574de&scoped=true&"
import script from "./VIPRefundInfo.vue?vue&type=script&lang=js&"
export * from "./VIPRefundInfo.vue?vue&type=script&lang=js&"
import style0 from "./VIPRefundInfo.vue?vue&type=style&index=0&id=037574de&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037574de",
  null
  
)

export default component.exports